import { Box, styled } from '@mui/material';
import React from 'react';

const StyledEmptyStateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  textAlign: 'center',
  padding: theme.spacing(4),
  '& .MuiSvgIcon-root': {
    fontSize: '4rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
}));

interface EmptyStateContainerProps {
  children: React.ReactNode;
}

export const EmptyStateContainer: React.FC<EmptyStateContainerProps> = ({ children }) => {
  return <StyledEmptyStateContainer>{children}</StyledEmptyStateContainer>;
}; 